import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  addTableRow,
  deleteTableRow,
  getCoversAndCoverTypes,
  getCoversAndCoverTypesFromStore,
  getSTCoptionsCoversDynTableDetailsCover,
  getSTCoptionsCoversDynTableDetailsReason,
  getSTCoptionsCoversDynTableOrder,
  updateCoverInRow,
  updateReason,
} from "../store/quotes";
import * as theme from "../theme";
import DeleteIcon from "@material-ui/icons/Delete";
import { PossibleApiStatusValues } from "../store/helperfuncs";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/styles";
import { getBrokerInformation } from "../store/broker";
import translations from "../utils/translations";

const CoverageRcmd = () => {
  const brokerage = useSelector(getBrokerInformation);
  const languagecode = brokerage.information.languagepreference;

  // Translation object for different languages
  const translations = {
    en: {
      coverageInstruction:
        "Please select other coverages that you would like your client to consider. These will be added, together with their general definitions, on the recommendation page. You can also add a comment or recommended limit next to each coverage.",
    },
    fr: {
      coverageInstruction:
        "Veuillez sélectionner d'autres couvertures que vous aimeriez que votre client envisage. Celles-ci seront ajoutées, ainsi que leurs définitions générales, sur la page de recommandation. Vous pouvez également ajouter un commentaire ou une limite recommandée à côté de chaque couverture.",
    },
  };

  return (
    <div
      style={{
        minHeight: "7vh",
        paddingLeft: "9vmin",
        fontSize: "1.5vmin",
        paddingTop: "1vh",
      }}
    >
      <span style={{ fontFamily: "GibsonLightIt" }}>
        {translations[languagecode]?.coverageInstruction}
      </span>
      <CoverageReasonTable />
    </div>
  );
};

const CoverageReasonTable = () => {
  const dispatch = useDispatch();
  const coversAndCoverTypes = useSelector(getCoversAndCoverTypesFromStore);
  useEffect(() => {
    if (coversAndCoverTypes === PossibleApiStatusValues.notstarted) {
      dispatch(getCoversAndCoverTypes());
    }
  }, []);
  let colWidth = {
    coverage: "40%",
    reason: "",
    delete: "10%",
  };

  colWidth.reason = `calc(100% - ${colWidth.coverage} - ${colWidth.delete})`;
  return (
    <div
      style={{
        minHeight: "50vh",
        paddingTop: "1.5vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <TableHeading colWidth={colWidth}></TableHeading>
      {coversAndCoverTypes === PossibleApiStatusValues.loading ||
      coversAndCoverTypes === PossibleApiStatusValues.notstarted ? (
        ""
      ) : (
        <TableRows colWidth={colWidth}></TableRows>
      )}
      <AddRow></AddRow>
    </div>
  );
};

const AddRow = () => {
  const brokerage = useSelector(getBrokerInformation);
  const languagecode = brokerage.information.languagepreference;
  const [hovered, setHovered] = useState(false);
  const dispatch = useDispatch();
  const handleAddClick = () => {
    dispatch(addTableRow());
  };
  return (
    <div
      style={{
        width: "100%",
        height: "6vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "60%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontFamily: "GibsonRegular",
          letterSpacing: 1.3,
          backgroundColor: !hovered
            ? theme.COLORS.little_darker_lightindigo
            : theme.COLORS.secondary_skyblue,
          color: theme.COLORS.dark_navy_blue,
          border: 0,
          cursor: "pointer",
          borderRadius: 7,
        }}
        onMouseOver={() => {
          setHovered(true);
        }}
        onMouseOut={() => {
          setHovered(false);
        }}
        onClick={handleAddClick}
      >
        {translations[languagecode].add}
      </div>
    </div>
  );
};

const TableRows = ({ colWidth }) => {
  const tableorder = useSelector(getSTCoptionsCoversDynTableOrder);
  return (
    <div style={{ minHeight: "5vh" }}>
      {tableorder.map((id) => (
        <EachTableRow key={id} id={id} colWidth={colWidth}></EachTableRow>
      ))}
    </div>
  );
};
const EachTableRow = ({ colWidth, id }) => {
  const [hovered, setHovered] = useState(false);
  const dispatch = useDispatch();
  const brokerage = useSelector(getBrokerInformation);
  const languagecode = brokerage.information.languagepreference;
  const handleDeleteClick = () => {
    dispatch(deleteTableRow({ rowid: id }));
  };
  const reasonDB = useSelector(getSTCoptionsCoversDynTableDetailsReason(id));
  var coversAndCoverTypes = useSelector(getCoversAndCoverTypesFromStore);
  coversAndCoverTypes = coversAndCoverTypes.filter(
    (cover) => typeof cover?.name === "object" && cover.name !== null
  );

  const [reason, setReason] = useState(reasonDB);
  const handleChange = (event) => {
    setReason(event.target.value);
  };
  const handleBlur = (event) => {
    dispatch(updateReason({ rowid: id, value: event.target.value }));
  };
  const onChangeHandle = (event, value) => {
    dispatch(updateCoverInRow({ rowid: id, value }));
  };

  const CssTextField = withStyles({
    root: {
      "& label.Mui-focused": {
        color: "white",
      },
      "& .MuiInput-underline:after": {
        borderBottomColor: "white",
      },
      "& .MuiInput-icon": {
        color: "white",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "white",
        },
        "&:hover fieldset": {
          borderColor: "white",
        },
        "&.Mui-focused fieldset": {
          borderColor: "white",
        },
      },
    },
    icon: {
      color: "white",
    },
  })(TextField);
  const useStyles = makeStyles({
    root: {
      color: "white",
      width: "90%",
      backgroundColor: theme.COLORS.primary_navyblue,
      fontFamily: "GibsonSemiBd",
      broder: "2px solid white",
      "& .MuiAutocomplete-listbox": {
        border: "2px solid white",
        minHeight: 400,
        color: "green",
        fontSize: 18,
        //hover discussed above
        "& li": {
          //list item specific styling
          border: "2px solid green",
          borderRadius: 4,
        },
      },
      "& .MuiAutocomplete-root fieldset": {
        color: "white",
        border: "2px solid white",
      },
    },
    outerRoot: {
      fontFamily: "GibsonSemiBd",
      border: 0,
      color: "white",
    },
    input: {
      color: "blue",
    },
    textfield: {
      "& .MuiButtonBase-root.MuiAutocomplete-clearIndicator": {
        color: "white",
      },
      "& .MuiButtonBase-root.MuiAutocomplete-popupIndicator": {
        color: "white",
      },
      "& .MuiInputBase-input.MuiAutocomplete-input": {
        color: "white",
      },
      "& #custom-autocomplete-label": {
        //or could be targeted through a class
        color: "brown",
      },
    },
    autocmpt: {
      "& .MuiAutocomplete-root fieldset:hover": {
        color: "white",
        borderColor: "white",
      },
    },
    icon: {
      color: "white",
    },
  });
  const classes = useStyles();

  const coverselected = useSelector(
    getSTCoptionsCoversDynTableDetailsCover(id)
  );

  return (
    <div
      key={id}
      style={{
        width: "100%",
        minHeight: "5vh",
        backgroundColor: theme.COLORS.primary_navyblue,
        display: "flex",
        flexDirection: "row",
        zIndex: 11,
      }}
    >
      <div
        style={{
          width: colWidth.coverage,
          fontFamily: "GibsonRegular",
          color: "white",
          display: "flex",
          alignItems: "center",
          minHeight: "5vh",
          paddingLeft: "3%",
          borderLeft: "2px solid white",
          borderBottom: "2px solid white",
        }}
      >
        <Autocomplete
          id={`${id}_ctype_${id}`}
          options={coversAndCoverTypes}
          getOptionLabel={(option) => option?.name[languagecode]}
          onChange={onChangeHandle}
          value={coverselected}
          className={classes.autocmpt}
          // PopperComponent={CustomPopper}
          classes={{
            root: classes.root,
          }}
          style={{ fontFamily: "GibsonSemiBd" }}
          renderInput={(params) => (
            <CssTextField
              {...params}
              variant="outlined"
              margin="dense"
              classes={{
                root: classes.root,
              }}
              className={classes.textfield}
              SelectProps={{
                native: true,
                classes: {
                  icon: classes.icon,
                },
              }}
              // onFocus={() => {
              //   if (helpTipPB.VerticalHelpOrTipFncs.changeText) {
              //     helpTipPB.VerticalHelpOrTipFncs.changeText(
              //       this.props.questionHint
              //     );
              //   }
              // }}
              // onBlur={() => {
              //   if (helpTipPB.VerticalHelpOrTipFncs.changeText) {
              //     helpTipPB.VerticalHelpOrTipFncs.changeText("");
              //   }
              // }}
            />
          )}
        ></Autocomplete>
      </div>
      <div
        style={{
          width: colWidth.reason,
          fontFamily: "GibsonRegular",
          color: "white",
          display: "flex",
          alignItems: "center",
          minHeight: "12vh",
          paddingLeft: "3%",
          borderLeft: "2px solid white",
          borderBottom: "2px solid white",
        }}
      >
        <textarea
          style={{
            width: "100%",
            height: "80%",
            padding: "2vmin",
            backgroundColor: theme.COLORS.primary_navyblue,
            color: "white",
            border: `2px solid ${theme.COLORS.little_darker_lightindigo}`,
            borderRadius: 5,
            letterSpacing: 1.2,
          }}
          onChange={handleChange}
          onBlur={handleBlur}
          value={reason}
        ></textarea>
      </div>
      <div
        style={{
          width: colWidth.delete,
          fontFamily: "GibsonRegular",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "5vh",
          paddingLeft: "3%",
          borderRight: "2px solid white",
          borderBottom: "2px solid white",
          zIndex: 10,
        }}
      >
        <DeleteIcon
          style={{
            display: "block",
            color: hovered ? theme.COLORS.secondary_skyblue : "white",
            cursor: "pointer",
          }}
          onMouseOver={() => {
            setHovered(true);
          }}
          onMouseOut={() => {
            setHovered(false);
          }}
          onClick={handleDeleteClick}
        ></DeleteIcon>
      </div>
    </div>
  );
};

const TableHeading = ({ colWidth }) => {
  const brokerage = useSelector(getBrokerInformation);
  const languagepreference = brokerage.information.languagepreference;
  return (
    <div
      style={{
        width: "100%",
        height: "4vh",
        backgroundColor: "white",
        borderTopRightRadius: 7,
        borderTopLeftRadius: 7,
        display: "flex",
        flexDirection: "row",
      }}
    >
      <div
        style={{
          width: colWidth.coverage,
          fontFamily: "GibsonRegular",
          color: theme.COLORS.primary_navyblue,
          display: "flex",
          alignItems: "center",
          height: "100%",
          paddingLeft: "3%",
        }}
      >
        {translations[languagepreference].coverage}
      </div>
      <div
        style={{
          width: colWidth.reason,
          fontFamily: "GibsonRegular",
          color: theme.COLORS.primary_navyblue,
          display: "flex",
          alignItems: "center",
          height: "100%",
          paddingLeft: "3%",
          borderLeft: `2px solid ${theme.COLORS.dark_navy_blue}`,
        }}
      >
        {translations[languagepreference].reasonLimit}
      </div>
    </div>
  );
};

export default CoverageRcmd;
